import styled, { keyframes } from 'styled-components';
import React,{ useEffect, useState,useRef } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import Anchor from '../Anchor'
import { calculate_engagement_by_anchor } from "./caluclate_engagement";
import { SURVEY_TYPE } from "constants/surveys";
import ParticipationChart from "./ParticipationChart";
import Loading from './Loading';
import Empty from './Empty';
import { Dropdown,Checkbox  } from "semantic-ui-react";
import { filter_data } from "reports/Tag/calculations";
import {calculateAverageScores} from "./calculate_question"
import SlideBackground from "assets/images/UI/slide_background.svg"



const Questions = ({slideData, updateSlideData,loading}) =>{

    const [selectedFactor, setSelectedFactor] = useState(null);
    const [includeOutcomes, setIncludeOutcomes] = useState(true);
    const [factorDropdown, setFactorDropdown] = useState([]);

    const [questionData, setQuestionData] = useState([]);

     // Ref to prevent cyclical updates
     const skipAnchorEffect = useRef(false);


    const anchor = useSelector((state) => state.audit?.anchor, shallowEqual);
    const selectedFilters = useSelector((state) => state.audit?.new_filters,shallowEqual);
    const coreData = useSelector((state) => state.audit?.core_data, shallowEqual);
    const data = useSelector((state) => state.audit?.raw_data, shallowEqual);

       // Update factor dropdown when coreData changes
          useEffect(() => {
            if (coreData) {
              let options = [{key:0, text:"Highest scoring questions", value:'Highest'},{key:1, text:"Lowest scoring questions", value:'Lowest'}] 
              coreData.questions.dimensions.flatMap((dimension, i) =>
              dimension.factors.map((factor) =>{
                  options.push({
                      key: factor.id+factor.title,
                      text: factor.title,
                      value: { ...factor, dimension: i, type: 'factor' }
                  })
              })
            );
      
          //Add the outcome factors here
            coreData?.outcomeQuestions?.questions.map((q) => {
              options.push({
                  key: q.id+q.title,
                  text: q.name,
                  value: { ...q, type: 'outcome' }
              })
              })
        
              setFactorDropdown(options);
      
              if(!slideData?.selectedFactor){
                  setSelectedFactor(options[0].value);
                }
            }
          }, [coreData]);

        useEffect(() => {
            if(selectedFactor){
                const latest_data = filter_data(data[0].responses, selectedFilters)
                const questions = coreData.questions
                const outcomeQ = coreData.outcomeQuestions
                setQuestionData(calculateAverageScores(latest_data,selectedFactor,questions,outcomeQ,includeOutcomes))
            }

        },[selectedFactor,includeOutcomes] )


         useEffect(() => {
    
            if (slideData && slideData.questionData) {
                setQuestionData(slideData.questionData);
                setSelectedFactor(slideData.selectedFactor);
                setIncludeOutcomes(slideData.includeOutcomes);
            }
            if(Object.keys(slideData).length === 0){
                setSelectedFactor(null);
            }

          }, [slideData]);

    

  
     // Handle anchor changes from user input
     useEffect(() => {

        if (!slideData || slideData.selectedFactor !== selectedFactor || slideData.questionData !== questionData || slideData.includeOutcomes !== includeOutcomes) {
            const newSlideData = {
            ...slideData,
            title:getTitle(),
            sub_text:getDescription(),
            questionData,
            slide_template_id: 6,
            includeOutcomes,
            selectedFactor,
          };
          if (JSON.stringify(newSlideData) !== JSON.stringify(slideData)) {
            updateSlideData(newSlideData);
           
          }
        }
      }, [questionData]);

      const handleFactorChange = (e, { value }) => {
        setSelectedFactor(value);
      };

      const handleToggle = (e, { checked }) => {
        setIncludeOutcomes(checked);
      };
    

    const getTitle = () =>{
        if(selectedFactor == null){
            return "Question Analysis Slide"
        }

        if(selectedFactor == "Highest"){
            return "Highest scoring questions"
        }
        else if(selectedFactor == "Lowest"){
            return "Lowest scoring questions"
        }
        else if(selectedFactor.type == "factor"){
            return selectedFactor.title
        }
        else if(selectedFactor.type == "outcome"){
            return selectedFactor.name
        }
    }

    const getDescription = () =>{
        if(selectedFactor == null){
            return "Select a factor to view the questions that were asked in the factor"
        }

        if(selectedFactor == "Highest"){
            return "These are the 5 questions that scored the highest in the survey."
        }
        else if(selectedFactor == "Lowest"){
            return "These are the 5 questions that scored the lowest in the survey"
        }
        else if(selectedFactor.type == "factor"){
            return `These are the questions that were asked in the ${selectedFactor.title} factor`
        }
        else if(selectedFactor.type == "outcome"){
            return `These are the questions that were asked in the ${selectedFactor.name} factor`
        }
    }

   
    

    if(loading){
        return <Loading/>
    }

      

    return (
        <Container>
        <T1>Question Analysis Slide</T1>
        <SubTitle>Slide Options</SubTitle>
        <OptionArea>

          <div style={{ marginRight: 20 }}>
            <OptionTitle>Question Type</OptionTitle>
            <Dropdown
              placeholder='Select Factor'
              selection
              options={factorDropdown}
              onChange={handleFactorChange}
              value={selectedFactor}
            />

           
          </div>

          {selectedFactor == 'Highest' || selectedFactor == "Lowest" ? 
          <Checkbox
                    toggle
                    label="Include Outcomes"
                    checked={includeOutcomes}
                    onChange={handleToggle}
                    style={{marginTop:35}}
                />:""}

        </OptionArea>
        {selectedFactor && 
        <SlidePreview>
          <SlideTitle>{getTitle()}</SlideTitle>
          <Description>
            {getDescription()}
          </Description>

          <QuestionArea>
                {questionData.map((question,index) => (
                    <>
                    <Row>
                        <Num>{index+1}.</Num>
                        <div>
                        <QuestionItem>
                            {`${question.question}`}
                            <span style={{ color: '#2D70E2', fontWeight: 600 }}>
                                {`\u00A0(${(question.average.toFixed(1) * 10)}%)\u00A0`}
                            </span>
                            {selectedFactor === 'Highest' || selectedFactor === 'Lowest' ? (
                                <Factor>- {question.factorName}</Factor>
                            ) : (
                                ''
                            )}
                            </QuestionItem>
                        </div>
                    </Row>
                  
                    </>
                ))}
          </QuestionArea>
          <SlideFooter>innerlogic</SlideFooter>
        </SlidePreview> }
      </Container>
    )
}

export default Questions;

const fadeIn = keyframes`
from {
  opacity: 0;
  transform: translateY(-20px);
}
to {
  opacity: 1;
  transform: translateY(0);
}
`;


const Container = styled.div`
 opacity:0;

    animation: ${fadeIn} 1s ease-out forwards;
`
const SlidePreview = styled.div`
    width:100%;
    height:550px;
    display:flex;
    flex-direction:column;
    padding:20px;
    border:1px solid #e0e0e0;
    border-radius:10px;
    margin-top:20px;
    position:relative;
    overflow:hidden;
    background: linear-gradient(to right, #ecf5f9, #e9f4f8, #e5f2f6, #e1f1f4, #ddeff2, #d9eef0, #d5edef, #d1ebed, #ceeaeb, #cae8e9);

`

const Row = styled.div`
    display:flex;
`
const Num = styled.div`
    color:#2D70E2;
    font-size: 16px;
    font-weight:600;
    margin-right:5px;
`

const Factor = styled.span`
    margin-bottom:0px;
    color:grey;
`

const Description = styled.div`
    margin-top:0px;
    font-size: 14px;
    margin-bottom:20px;
`

const SlideTitle = styled.div`
    font-size: 24px;
    font-weight: bold;
    margin-bottom:10px;
    font-family: 'Raleway';
    color:#333333;
    margin-top:20px;
`

const SlideFooter = styled.div`
    position:absolute;
    bottom:0;
    font-size: 12px;
    width:calc(100% - 40px);
    padding:10px 0px;
    border-top:1px solid #e0e0e0;
    display:flex;
`

const QuestionArea = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:center;
    margin-top:40px;
`
const QuestionItem = styled.div`
    font-size: 16px;
    font-weight: 500;
    color:#2A3039;
    margin-bottom:20px;
    display:inline-block;

`

const OptionArea = styled.div`
    margin-bottom:20px;
    display:flex;
    padding:20px;
    background-color:#f9fbfd;
    width:100%;
`

const OptionTitle = styled.div`
    font-size:12px;
    font-weight:500;
    margin-bottom:5px;
`
const SubTitle = styled.div`
    font-size: 14px;
    margin-top:20px;
    margin-bottom:5px;
    font-weight:600;
`

const T1 = styled.div`
    font-size: 20px;
    font-weight: 600;
    margin-bottom:10px;
    color:#2A3039;
`

const SlideBackgroundImage = styled.img`
    position:absolute;
    bottom:-50%;
    right:0;
    opacity:0.3;
`